import {createAction} from '@reduxjs/toolkit'
import {
    IdCashDesksStateDataItem,

    typeCashDesksFilters,

} from 'model/dashboardCashDesks/dCashDesksReducer'

import {typePagination, typeRequestPagination} from '../system/constants'



// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data
export const dCashDesksSetDataAC = createAction(
    'D_CASHDESKS_SET_DATA',
    (
        dataList: IdCashDesksStateDataItem[],
    ) => ({payload: {dataList}})
)

// Action creator of set pagination
export const dCashDesksSetPaginationAC = createAction(
    'D_CASHDESKS_SET_PAGINATION',
    (
        pagination: typePagination,
    ) => ({payload: {pagination}})
)

// Action creator of set pageNumber in pagination
export const dCashDesksSetPageNumberAC = createAction(
    'D_CASHDESKS_SET_PAGE_NUMBER',
    (
        pageNumber: number,
    ) => ({payload: {pageNumber}})
)

// Action creator of set itemsForPage in pagination
export const dCashDesksSetItemsForPageAC = createAction(
    'D_CASHDESKS__SET_ITEMS_FOR_PAGE',
    (
        itemsForPage: number,
    ) => ( { payload: { itemsForPage } } )
)


// Action creator of saga set data
export const dCashDesksSetDataSagaAC = createAction(
    'D_CASHDESKS_SET_DATA_SAGA',
    (
        filters: typeCashDesksFilters,
        paginationRequest: typeRequestPagination
    ) => ({payload: { filters, paginationRequest}})
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set item data
export const dCashDesksSetDetailItemAC = createAction(
    'D_CASHDESKS_SET_DETAIL_ITEM',
    (detailItemId: string) => ({payload: detailItemId})
)




// ---------------------------------------------------------------------------------------------------------------------
// Action creator of clear filtersForm
export const dCashDesksClearFiltersAC = createAction(
    'D_CASHDESKS_CLEAR_FILTERS',
)

// Action creator of set filtersForm
export const dCashDesksSetFiltersAC = createAction(
    'D_CASHDESKS_SET_FILTERS',
    (filtersObject: typeCashDesksFilters) => ({payload: filtersObject})
)

// Action creator of set filtersForm saga
export const dCashDesksSetFiltersSagaAC = createAction(
    'D_CASHDESKS_SET_FILTERS_SAGA',
    ( filtersObject: typeCashDesksFilters, paginationRequest: typeRequestPagination) => ({payload: { filtersObject, paginationRequest}})
)

